module.exports = __webpack_public_path__ + "img/laboratorio_9-16_540.b417f15d.webp";